import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Button from "../ui/Button";
import Divider from "../ui/Divider";
import Card from "../ui/Card";

export default function ReportsPrintExport(props) {

    const {
        controller = "",
        route = "",
        callback = () => { }
    } = props;


    const [index, setIndex] = useState(0);

    const selectOption = option => {
        setIndex(option === "CSV" ? 0 : 1);
        callback(option);
    };

    const next = () => {
        setIndex(current => current === 0 ? 1 : 0);
    };

    const prev = () => {
        setIndex(current => current === 1 ? 0 : 1);
    };

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: () => callback(false) },
            { key: KBD.ARROW_LEFT, action: prev },
            { key: KBD.ARROW_RIGHT, action: next },
            { key: KBD.TAB, action: next },
            { key: KBD.SHIFT_TAB, action: prev },   
            {
                key: KBD.PAGE_DOWN,
                action: () => selectOption(index === 0 ? "CSV" : "XLSX")
            }
        ];

        return listen(controller, route, actions, false, [KBD.ARROW_LEFT, KBD.ARROW_RIGHT, KBD.TAB, KBD.SHIFT_TAB, KBD.PAGE_DOWN]);
    }, [controller, route, index]);

    return (
        <Space size={20}>
            <div onClick={() => selectOption("CSV")} style={{ width: "250px" }}>
                <div className="shim" /> <div className="shim" />
                <Card className={(index === 0) ? "card-btn selected" : "card-btn"} style={{ "width": "200px", "padding": "3px 15px" }}>
                    <div style={{ "fontSize": "28px", "textAlign": "center" }}>CSV</div>
                    <div className="shim" />
                    <Label style={{ "color": "var(--text)", "textAlign": "center", "marginTop": "-10px" }}><em><small>Comma separated text file (.csv)</small></em></Label>
                    <div style={{ "textAlign": "center", "color": "var(--text-blue)" }}><strong>{((index === 0)) ? "PgDn" : <>&nbsp;</>}</strong></div>
                </Card>
                <div className="shim" /><div className="shim" />
                <Divider />
                <div className="shim" />
                <Label style={{ "textAlign": "center" }}>Comma separated text file (.csv) that can be opened in any spreadsheet application (Excel, Google Sheets, etc.). Most compatible</Label>
            </div>

            <div onClick={() => selectOption("XLSX")}style={{ width: "250px" }}>
                <div className="shim" /> <div className="shim" />
                <Card className={(index === 1) ? "card-btn selected" : "card-btn"} style={{ "width": "200px", "padding": "3px 15px" }}>
                    <div style={{ "fontSize": "28px", "textAlign": "center" }}>XLSX </div>
                    <div className="shim" />
                    <Label style={{ "color": "var(--text)", "textAlign": "center", "marginTop": "-10px" }}><em><small>Excel Spreadsheet format (.xlsx)</small></em></Label>
                    <div style={{ "textAlign": "center", "color": "var(--text-blue)" }}><strong>{((index === 1)) ? "PgDn" : <>&nbsp;</>}</strong></div>
                </Card>
                <div className="shim" /><div className="shim" />
                <Divider />
                <div className="shim" />
                <Label style={{ "textAlign": "center" }}>Microsoft Excel Spreadsheet format (.xlsx) that can be opened in many spreadsheet apps, but is native to Microsoft Excel.</Label>
            </div>
        </Space>
    );
}